<template>
    <div class="mb-xl-10">
        <v-row class="justify-center align-center">
            <v-col cols="12" sm="8" md="7" lg="3">
                <span
                    class="
                        text-display-large text-left
                        font-weight-regular
                        text-typography1
                    "
                >
                    Pricing information
                </span>
            </v-col>
            <v-col cols="12" sm="8" md="7" lg="5">
                <div class="text text-typography2 text-h6">
                    ValueTrack Project Charging Ending April 1st, 2023
                </div>
                <ul class="text-body-1 text-start">
                    <li>
                        ArupCompute is a foundational product in Arup’s
                        <a
                            href="https://arup.sharepoint.com/teams/global-design-automation-team/SitePages/Tools-Index.aspx"
                            target="_blank"
                            >Global Automation portfolio</a
                        >. As such, it has been increasingly leveraged as a
                        central “building block” for larger automation
                        solutions. As a platform for storing and sharing
                        algorithms, it provides teams with access to a
                        centralized and reusable set of engineering calculations
                        and libraries. Together with other Global Automation
                        products like
                        <a
                            href="https://arup.sharepoint.com/teams/global-design-automation-team/SitePages/Speckle.aspx?web=1"
                            target="_blank"
                            >Speckle</a
                        >
                        and
                        <a
                            href="https://arup.sharepoint.com/teams/global-design-automation-team/SitePages/Digital-Design-Brief.aspx?web=1"
                            target="_blank"
                            >Digital Design Brief (DDB)</a
                        >, ArupCompute serves as digital infrastructure for new
                        tools and workflows.
                    </li>
                    <li>
                        To support its continued use as a core and common
                        component, so that teams are enabled to build out new
                        and better combined automation solutions, the Digital
                        Executive and Commercial Executive have decided to move
                        ArupCompute out of ValueTrack. This means that,
                        <b
                            >from April 1st, 2023, ArupCompute usage will no
                            longer be charged to projects via ValueTrack</b
                        >. Support for this product will be centrally funded.
                    </li>
                    <li>
                        Users will still need to provide a job number when using
                        ArupCompute, but there will be no charge. This will
                        allow us to collect project usage data, which is vital
                        for justifying continued support of ArupCompute and
                        crucial for shaping direction of growth for the product.
                    </li>
                </ul>
            </v-col>
        </v-row>
    </div>
</template>

<style scoped>
li {
    list-style-position: outside;
    list-style-type: none;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
}

ul {
    padding: 0;
}
</style>
